<template>
	<div class="full">
		<el-radio-group v-model="tabPosition" size="mini" style="margin-bottom: 10px;margin-left: 6px;" @input="selecChange">
			<el-radio-button v-for="(item,index) in typelist" :key="index" :label="item.name">{{item.name}}</el-radio-button>
		</el-radio-group>
		<div style="width: 100%;" v-if="currentfile.length!=0">
			<upload ref="upload" :value="currentfile" :downloadConfig="downloadConfig" :disabled="true" :formCreateInject="true" />
		</div>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				typelist:[],
				tabPosition:null,
				currentfile:[],
				downloadConfig:{
					name:{
						prefix:'prefix',
						suffix:'',
					}
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if(this.row){
				this.getMaterial()
				
			}
		},
		computed: {

		},

		methods: {
			getMaterial() {
				this.loading = true
				this.$api.goods.getmaterial({code:this.row.code}).then((res) => {
					this.typelist = []
					this.tabPosition = null
					for(let i in res){
						if(res[i].length){
							this.typelist.push({
								name:i,
								file:res[i]
							})
							if(!this.tabPosition){
								this.tabPosition = i
								this.currentfile = res[i]
								this.downloadConfig.name.prefix = '【'+ i +'】' + this.row.code + '_' +this.row.name +'_'+this.row.model
							}
						}
					}
					
					

					//console.log(this.typelist)
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			selecChange(e){
				this.downloadConfig.name.prefix = '【'+ e +'】' + this.row.code + '_' +this.row.name +'_'+this.row.model
				this.typelist.forEach((item)=>{
					if(item.name==e){
						this.currentfile = item.file
					}
				})
				console.log(this.currentfile)
			}
		},
		components: {
			upload
		}
	}
</script>